/*************************************************/
/* Collapsed text                                */
/*************************************************/
import customEventsNames from './../customEventsNames';

export function collapsedText() {
    const collapsedTextClass = "collapsed-text--collapsed";
    const collapsedTextButtonSelector = ".collapsed-text__button";
    const collapsedTextButtonCloseSelector = ".collapsed-text__button-close";

    const init = function () {
        var collapsedTextButtons = document.querySelectorAll(collapsedTextButtonSelector);
        var collapsedTextButtonsClose = document.querySelectorAll(collapsedTextButtonCloseSelector);
        if (collapsedTextButtons.length > 0) {
            collapsedTextButtons.forEach(button => {
                button.addEventListener('click', e => {
                    const collapsedTextField = e.target.previousElementSibling;
                    const collapsedTextButtonClose = e.target.nextElementSibling;
                    if(collapsedTextField) {
                        collapsedTextField.style.height = collapsedTextField.scrollHeight + 'px';
                        collapsedTextField.classList.remove(collapsedTextClass);
                        collapsedTextField.setAttribute('aria-expanded',true);
                        collapsedTextButtonClose.style = 'display: flex';
                        e.target.style.display = 'none';

                        const parentSlide = button.closest('.swiper-slide');
                        if(parentSlide) {
                            var expandCollapsedTextEvent = new CustomEvent(customEventsNames.expandedCollapsedText,{
                                detail: {
                                    height:collapsedTextField.scrollHeight
                                }
                            });

                            parentSlide.dispatchEvent(expandCollapsedTextEvent);
                        }
                    }
                });
            collapsedTextButtonsClose.forEach(closeButton => {
                closeButton.addEventListener('click', e => {
                    const collapsedButton = e.target.previousElementSibling;
                    const collapsedTextField = collapsedButton.previousElementSibling;
                    if(collapsedTextField) {
                        collapsedTextField.style.height = '0px';
                        collapsedTextField.classList.add(collapsedTextClass);
                        collapsedTextField.setAttribute('aria-expanded',false);
                        collapsedButton.style.display = 'flex';
                        e.target.style.display = 'none';

                        const parentSlide = button.closest('.swiper-slide');
                        if(parentSlide) {
                            var collapseCollapsedTextEvent = new CustomEvent(customEventsNames.collapsedCollapsedText);

                            parentSlide.dispatchEvent(collapseCollapsedTextEvent);
                        }
                    }
                })
            })
            });
        }
    };


    init();
}
